import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HeroSection from '../components/HeroSection';
import CryptoTicker from '../components/CryptoTicker';
import TradingSignalsSection from '../components/TradingSignalsSection';
import PerformanceSection from '../components/PerformanceSection';
import FeaturesSection from '../components/FeaturesSection';
import PricingSection from '../components/PricingSection';
// import TestimonialsSection from '../components/TestimonialsSection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

const Home: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // If navigated with a target section, scroll to it
    const state = location.state as { scrollTo?: string } | null;
    if (state?.scrollTo) {
      const el = document.getElementById(state.scrollTo);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location.state]);
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 text-slate-900 dark:text-slate-50">
      {/* Hero Section */}
      <HeroSection />

      {/* Crypto Ticker */}
      <CryptoTicker />

      {/* Trading Signals Section */}
      <div id="signals">
        <TradingSignalsSection />
      </div>

      {/* Performance Record Section */}
      <div id="performance">
        <PerformanceSection />
      </div>

      {/* Features Section */}
      <div id="features">
        <FeaturesSection />
      </div>

      {/* Pricing Section */}
      <div id="pricing">
        <PricingSection />
      </div>

      {/* Testimonials */}
      {/* <TestimonialsSection /> */}

      {/* CTA Section */}
      <CTASection />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Home;
